'use strict';
/**
 * Exception thrown when the message does not have the required data.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var ExIncompleteMessage =
/**
   * @param {string} source The name of the function that threw the exception.
   * @param {EPending|ELiving|EDying} entry The entry that requested more
   * information.
   * @param {MResponse} message The message lacking data.
   */
function ExIncompleteMessage(source, entry, message) {
  _classCallCheck(this, ExIncompleteMessage);

  this.source = source;
  this.entry = entry;
  this.message = message;
};

;
module.exports = ExIncompleteMessage;